const placeholders = {
  en: [
    "Search 'Business' templates",
    "Find 'Portfolio' sites",
    "Explore 'E-commerce' ideas",
    "See 'Blog' layouts"
  ],
  es: [
    "Buscar 'Negocios'",
    "Sitios de 'Portafolio'",
    "Diseños de 'E-commerce'",
    "Ver diseños de 'Blog'"
  ],
  uk: [
    "Шаблони 'Бізнес'",
    "Сайти 'Портфоліо'",
    "Дизайни 'E-commerce'",
    "Макети 'Блог'"
  ],
  ru: [
    "Шаблоны 'Бизнес'",
    "Сайты 'Портфолио'",
    "Дизайны 'E-commerce'",
    "Макеты 'Блог'"
  ],
  fr: [
    "Modèles 'Entreprise'",
    "Sites 'Portfolio'",
    "Designs 'E-commerce'",
    "Mises en page 'Blog'"
  ],
  br: [
    "Modelos de 'Negócios'",
    "Sites de 'Portfólio'",
    "Designs de 'E-commerce'",
    "Layouts de 'Blog'"
  ],
  tr: [
    "'İş' şablonları",
    "'Portföy' siteleri",
    "'E-ticaret' tasarımı",
    "'Blog' düzenleri"
  ],
  de: [
    "'Business' Vorlagen",
    "'Portfolio' Seiten",
    "'E-Commerce' Design",
    "'Blog' Layouts"
  ]
};

module.exports = { placeholders };
